import { html, unsafeCSS, type CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LibElement } from '../lib-element';
import iconCss from './lib-icon.css';

@customElement('lib-icon')
export class LibIcon extends LibElement {
    static override readonly shadowRootOptions: ShadowRootInit = {
        ...LibElement.shadowRootOptions,
        delegatesFocus: false,
    };
    static override readonly styles: CSSResultGroup = [LibElement.hostStyles, unsafeCSS(iconCss)];

    @property({ attribute: 'icon-url' }) iconUrl = '';
    @property({ type: Boolean, reflect: true }) spinning = false;

    override render() {
        const iconStyle = `--icon-href: url(${JSON.stringify(this.iconUrl)})`;
        return html`<i part="icon" aria-hidden="true" style=${iconStyle}></i>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'lib-icon': LibIcon;
    }
}
